'use strict';

import LessonApi from '@api/lessons';

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[app::services::registration]';

const preview = async (lesson) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await LessonApi.preview(lesson.id);
    return response.data;
}

export default {
    preview
};